import { useId } from "react";
import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";

import { setAdTypesParams } from "@/src/store/filter";

import InfoSvg from "assets/svg/info.svg";

import CheckBoxItem from "@/src/components/common/checkbox-item";

import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const AdTypeFilter = ({ information }) => {
  const keyId = useId();
  const reduxAdtypeFilter = useSelector((state) => state.filter.adtypesitems);

  const dispatch = useDispatch();

  const handleTypeCheckbox = (e, item) => {
    const newCriteriaParams = e.target.checked
      ? [...reduxAdtypeFilter, { key: item.key, value: item.config }]
      : reduxAdtypeFilter.filter((element) => element.key !== item.key);
    dispatch(setAdTypesParams(newCriteriaParams));
  };

  const manipulateToAddTypeFilter = () => {
    const newInformation = information.map((item, index) => {
      if (item.key === "price_index") {
        item.name = "JetFırsat İlanlar";
        item.tooltipText = `Benzerlerine göre avantajlı fiyatlara sahip ilanlar`;
        return item;
      }
      return item;
    });

    return newInformation.map((item, index) => {
      return (
        <div key={`${keyId}+${index}`} className={styles.checboxItemWrapper}>
          <CheckBoxItem
            title={item?.name}
            onChange={(e) => handleTypeCheckbox(e, item)}
            checkBoxClass={styles.checkBoxClass}
            defaultChecked={isCheckFilter(item.key)}
            // Item içerisine manuel olarak eklenen badge için yazılmıştır. Be tarafının badge eklemesi durumunda güncellenmelidir.
            badge={item?.badge}
          />
          {item.tooltipText && (
            <span className={styles.iconWrap}>
              <InfoSvg />
            </span>
          )}
        </div>
      );
    });
  };

  const isCheckFilter = (key) => reduxAdtypeFilter.some((item) => item.key === key);

  return <div className={styles.checkBoxWrapper}>{manipulateToAddTypeFilter()}</div>;
};

AdTypeFilter.propTypes = {
  information: PropTypes.array,
};

export default AdTypeFilter;
